module.exports = __webpack_public_path__ + "img/emptystar.b6fdd469.svg";